import { fun_PostAction } from "@/api/index";

// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [

      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        tenderReference: null, // 招标编号
        prjName: null, // 项目名称
        regulators: null, // 招标监管部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          isShow: true,
        },
        {
          label: "状态",
          slotName: "state",
        },
        {
          label: "标段",
          prop: "section",
        },
        {
          label: "录入人员",
          prop: "inputPersonName",
        },
        {
          label: "招标投标监管部门",
          prop: "regulators",
          width: "300",
        }
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      // 温馨提示
      tipList: [
      /*{
        type: "text",
        text: "（1）定标记录可重复录入，通过后原有的记录将会被作废！",
      }*/
      ],
    };
  },
  // 注册组件
  components: {},

  // 模板编译完成
  mounted() {
    // 默认打开项目评审列表
    this.fun_GetList();
  },

  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/evaluationRecord/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 甲方确认标志
      let tenderSigFlag = "";
      // 甲方确认状态不为空
      if(e.val.tenderSignedState != "" && e.val.tenderSignedState != null){
        // 设置为是
        tenderSigFlag = "1";
      }
      // 跳转详情页面
      this.$router.push({path: "/evaluationRecordDetail", query: { id: e.val.id, isTenderSignature: tenderSigFlag, type: "details" }});
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      // 跳转详情页面
      this.$router.push({path: "/evaluationRecordDetail", query: { type: "insert" }});
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0){
        // 如果勾选超过1条
        if(this.multipleSelection.length > 1){
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        }else{
          // 如果是自行招标
          if(this.multipleSelection[0].tenderMethod != '1'){
            // 则验证若是招标人则不能修改操作
            if(this.multipleSelection[0].tenderCorpFlag == '01'){
              // 提示，并清除选中数据
              this.$alert("该项目为委托招标请直接点击项目进入详情进行查看，不能修改项目数据。", "warning").then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
              return false;
            }
          }
          // 如果是提交状态
          if(this.multipleSelection[0].state == 'tj'){
            // 设置状态名称
            let stateName = "提交";
            // 招标人签章确认编号不为空
            if(this.multipleSelection[0].tenderSignedId != "" && this.multipleSelection[0].tenderSignedId != null){
              // 招标人签章状态为提交
              if(this.multipleSelection[0].tenderSignedId == "tj"){
                // 设置状态名称
                stateName = "招标人确认中";
              }
            }
            // 提示，并清除选中数据
            this.$alert('该项目当前状态为“' + stateName + '”，不能修改！', "warning").then(() => {
              // 清除选中数据
              this.$refs.list.$refs.multipleTable.clearSelection();
            });
            return false;
          }
          // 如果状态为通过
          if(this.multipleSelection[0].state == 'tg'){
            // 如果是旧数据
            if(this.multipleSelection[0].latest == '0'){
              // 提示，并清除选中数据
              this.$alert('该项目当前状态为“作废”，不能修改！', "warning").then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
            }else{
              // 提示，并清除选中数据
              this.$alert('该项目当前状态为“通过”，不能修改！', "warning").then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
            }
            return false;
          }
          // 跳转详情页面
          this.$router.push({path: "/evaluationRecordDetail", query: {id: this.multipleSelection[0].id, type:"update"}});
        }
      }
    },
    /**
     * 删除
     */
    fun_Del(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键数组
        let keys = [];
        // 招标公告主键集合
        let announcementIds = [];
        // 遍历勾选
        for(const index in this.multipleSelection){
          // 如果是自行招标
          if(this.multipleSelection[index].tenderMethod != '1'){
            // 则验证若是招标人则不能修改操作
            if(this.multipleSelection[index].tenderCorpFlag == '01'){
              // 提示，并清除选中数据
              this.$alert("该项目为委托招标请直接点击项目进入详情进行查看，不能修改项目数据。", "warning").then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
              return false;
            }
          }
          // 如果是提交或者通过状态
          if(this.multipleSelection[index].state == 'tj' || this.multipleSelection[index].state == 'tg'){
            // 如果是旧数据
            if(this.multipleSelection[index].latest == '0'){
              // 提示，并清除选中数据
              this.$alert('该项目当前状态为“作废”，不能修改！', "warning").then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
            }else{
              // 提示，并清除选中数据
              this.$alert('该项目信息已通过或者已提交，无法进行删除或修改操作！', "warning").then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
            }
            return false;
          }
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/evaluationRecord/delete", {
            keys: keys,
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 获取一览表格数据
            this.fun_GetList();
          });
        });
      }
      // 如果未进行勾选
      else{
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
  }
};
